import "core-js/modules/es.array.filter";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.replace";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import env from '@tencent/vft-common/env';
import * as jrQrcode from 'jr-qrcode';
import { setUrlParam } from '@tencent/vft-common/util';
import IconShare from '@tencent/vft-component/IconShare';
import { format } from '@tencent/vft-utils';
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    shareInfo: {
      type: Object
    }
  },
  data: function data() {
    return {
      env: env,
      index: 0,
      key: Date.now(),
      base64: null
    };
  },
  watch: {
    value: function value(val) {
      if (val) {
        this.initShareInfo(Object.assign(this.params.shareCfg, {
          分享链接: this.params.shareUrl.replace(/qr\./, 'pg.')
        }), this.userService);
        return;
      } // 还原分享


      this.initShareInfo(this.setting.默认分享, this.userService);
    }
  },
  components: {
    CloudSealCard: function CloudSealCard() {
      return import('@tencent/cloud-seal-card');
    },
    IconShare: IconShare
  },
  computed: {
    shareList: function shareList() {
      return this.concertInfo.分享图切换配置;
    },
    cardId: function cardId() {
      var _ref = this.shareInfo || {},
          action = _ref.action,
          type = _ref.type;

      return action === 'buy' && type === 'other' ? 'ZGTwZwUVLG' : 'G8MVWtLVOJ';
    },
    params: function params() {
      var _ref2 = this.shareInfo || {},
          action = _ref2.action,
          type = _ref2.type,
          price = _ref2.price,
          giftCount = _ref2.giftCount,
          oid = _ref2.oid;

      var _this$userService = this.userService,
          headurl = _this$userService.headurl,
          nick = _this$userService.nick,
          vuid = _this$userService.vuid;
      var vipIcon = this.vipService.vipIcon;

      var _ref3 = this.shareList[this.index] || this.shareList[0],
          背景图 = _ref3.背景图,
          分享文案 = _ref3.分享文案;

      var _this$setting = this.setting,
          门票炫耀分享 = _this$setting.门票炫耀分享,
          门票赠送分享 = _this$setting.门票赠送分享,
          门票领取分享 = _this$setting.门票领取分享,
          门票买自己分享 = _this$setting.门票买自己分享;
      var _this$concertInfo = this.concertInfo,
          name = _this$concertInfo.名称,
          startTs = _this$concertInfo.开始时间,
          sticker = _this$concertInfo.分享图贴纸,
          pid = _this$concertInfo.pid;
      var beginTime = format(startTs / 1000, 'Y/MM/dd HH:mm');
      var res = {
        shareCfg: 门票炫耀分享,
        nick: nick,
        headImg: headurl,
        level: vipIcon,
        pic: 背景图,
        qrUrl: setUrlParam('ptag', 'qr.xy', 'https://m.film.qq.com/vip-activity/strawberry/index.html'),
        name: name,
        sticker: sticker,
        beginTime: beginTime
      }; // 购买多份分享给别人

      if (action === 'buy' && type === 'other') {
        res.price = price;
        res.giftMsg = 分享文案;
        res.giftCount = giftCount;
        res.qrUrl = setUrlParam('oid', oid, res.qrUrl);
        res.qrUrl = setUrlParam('uid', vuid, res.qrUrl);
        res.qrUrl = setUrlParam('pid', pid, res.qrUrl);
        res.qrUrl = setUrlParam('ptag', 'qr.zs', res.qrUrl);
        res.shareCfg = 门票赠送分享;
      } else if (action === 'buy') {
        // 买给自己的
        res.shareCfg = 门票买自己分享;
        res.label = '已购买';
        res.qrUrl = setUrlParam('ptag', 'qr.self', res.qrUrl);
      } else if (action === 'receive' || action === 'share' && this.mySupportCount === 0) {
        res.shareCfg = 门票领取分享;
        res.label = '已获得';
        res.qrUrl = setUrlParam('ptag', 'qr.lq', res.qrUrl);
      } else if (action === 'share' && this.mySupportCount > 0) {
        res.supportCount = this.mySupportCount;
      }

      res.shareUrl = res.qrUrl;
      console.debug(res.qrUrl);
      res.qrUrl = this.getQrCode(res.qrUrl);
      return res;
    },
    // 演唱会信息
    concertInfo: function concertInfo() {
      var _this = this;

      var list = (this.setting.演出场次 || []).filter(function (v) {
        return v.activity_name === _this.shareInfo.activity_name;
      });
      return list.length > 0 ? list[0] : this.setting.演出场次[0];
    },
    // 我支持的张数
    mySupportCount: function mySupportCount() {
      var activityName = this.concertInfo.activity_name;
      return this.$store.getters.mySupportCount(activityName);
    }
  },
  methods: {
    getQrCode: function getQrCode(qrUrl) {
      var options = {
        padding: 10,
        // 二维码四边空白（默认为10px）
        width: 256,
        // 二维码图片宽度（默认为256px）
        height: 256,
        // 二维码图片高度（默认为256px）
        correctLevel: 3,
        // 二维码容错level（默认为高）
        reverse: false,
        // 反色二维码，二维码颜色为上层容器的背景颜色
        background: '#ffffff' // 二维码背景颜色（默认白色）

      };
      return jrQrcode.getQrBase64(qrUrl, options);
    },
    changeImg: function changeImg() {
      // this.loading.show()
      this.index = this.index + 1 > this.shareList.length - 1 ? 0 : this.index + 1;
      this.key = Date.now();
    },
    reset: function reset() {
      // this.loading.hide()
      this.base64 = null;
    },
    close: function close() {
      this.reset();
      this.$emit('input', false);
      this.$emit('close');
    },
    success: function success(img) {
      // this.loading.hide()
      this.base64 = img;
    }
  }
};